import Axios from "../utils/Axios";
export type ChatDetailType = {
  sender_type: "STORE";
  read: number;
  created_at: string;
  read_at: string | null;
  chat: string;
  failed?: boolean;
};

const DirectMessageController = {
  getChats: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/directMessage/getChats";
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[knockknock 채팅 내용 불러오기 오류]" + oErr.toString(),
        data: undefined,
      };
    }
  },
  getChatRoomData: async (oParams: any) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL + "/directMessage/getChatRoomData";
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[knockknock 채팅 정보 불러오기 오류]" + oErr.toString(),
        data: undefined,
      };
    }
  },
  createChatRoomWithoutAreaId: async (oParams: any) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_URL +
        "/directMessage/createChatRoomWithoutAreaId";
      const response = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[knockknock 채팅방 생성하기 오류]" + oErr.toString(),
        data: undefined,
      };
    }
  },
  writeMessage: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/directMessage/writeMessage";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[knockknock 채팅 전송 오류]" + oErr.toString(),
        data: undefined,
      };
    }
  },
  finishChat: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_URL + "/directMessage/finishChat";
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: "[knockknock 채팅 종료 오류]" + oErr.toString(),
        data: undefined,
      };
    }
  },
};

export default DirectMessageController;
